(function () {
    'use strict';

    angular
        .module('vm.common')
        .factory('CurrentUserService', CurrentUserService);

    function CurrentUserService ($api) {
        let currentUserPromise;

        return {
            clean,
            get,
        };

        //////////////

        function clean () {
            currentUserPromise = null;
        }

        function get () {
            if (!currentUserPromise) {
                currentUserPromise = $api.get('profile/me')
                    .then((response) => {
                        return response.data;
                    })
                ;
            }

            return currentUserPromise;
        }
    }
}());